import { FormHelpSection } from "~components/Form/FormHelpSection";
import { FormSkeleton } from "~components/Form/FormSkeleton";
import { StyledEntrantSection } from "../../styles";
import { SkeletonContainer, StyledTitleSkeleton } from "./FixtureEntrantsSkeleton.styles";

export const FixtureEntrantsSkeleton = () => {
  const column = (
    <div>
      <FormHelpSection
        sectionTitle={<StyledTitleSkeleton active size="small" />}
        modalTitle={<StyledTitleSkeleton active size="small" />}
        fields={[]}
      />
      <StyledEntrantSection>
        {Array(6)
          .fill("")
          .map((_, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: it's ok to have index as a key in this case
            <div key={index}>
              <FormSkeleton />
            </div>
          ))}
      </StyledEntrantSection>
    </div>
  );

  return (
    <SkeletonContainer>
      {column}
      {column}
    </SkeletonContainer>
  );
};
